import { render, staticRenderFns } from "./requestInfo.vue?vue&type=template&id=15dc841c"
import script from "./requestInfo.vue?vue&type=script&lang=js"
export * from "./requestInfo.vue?vue&type=script&lang=js"
import style0 from "./requestInfo.vue?vue&type=style&index=0&id=15dc841c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports